module.exports = __webpack_public_path__ + "stripes-light.png?a3e462eea67ed33e8070b657f24a43fe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stripes-light.png
// module id = 233
// module chunks = 0